import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SiteDTO } from '../models/siteDTO.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SitesService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  /** Retrieve all the available sites */
  getAll() {
    return this.httpClient.get<SiteDTO[]>(
      `${environment.baseUrl}/sites`
    )
  }
}
